import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const EquipoEvaluador = ({ solicitudId }) => {
  let { id } = useParams();
  const [equipo, setEquipo] = useState([]);

  useEffect(() => {
    axios
      .get(
        `https://suadesarrollo.azurewebsites.net/api/QEquipoUsuario?SolicitudId=${id}`,
      )
      .then((res) => setEquipo(res.data))
      .catch((err) => console.error(err));
  }, [solicitudId]);

  return (
    <div className="text-center">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Equipo Evaluador
          </h6>
          <div className="p-6 flex justify-center">
            <div className="card shadow-lg w-full max-w-5xl">
              {/* Header */}

              {/* Tabla */}
              <div className="overflow-x-auto">
                <center>
                  <table className="min-w-full text-left text-sm text-gray-700">
                    <thead className="bg-gray-100 text-gray-600 uppercase text-xs">
                      <tr>
                        <th className="px-6 py-3">Nombre</th>
                        <th className="px-6 py-3">Rol</th>
                        <th className="px-6 py-3">Evaluador ID</th>
                        <th className="px-6 py-3">Solicitud ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      {equipo.map((persona, index) => (
                        <tr
                          key={persona.id}
                          className="border-b hover:bg-blue-50 transition"
                        >
                          <td className="px-6 py-4">{persona.nombre}</td>
                          <td className="px-6 py-4">
                            <span className="px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-700">
                              {persona.nombreRol}
                            </span>
                          </td>
                          <td className="px-6 py-4">{persona.evaluadorId}</td>
                          <td className="px-6 py-4">{persona.solicitudId}</td>
                        </tr>
                      ))}
                      {equipo.length === 0 && (
                        <tr>
                          <td
                            colSpan="5"
                            className="px-6 py-4 text-center text-gray-500"
                          >
                            No hay registros disponibles.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquipoEvaluador;
